import { 
    GET_ALL_FORMULATION_BEGIN,
    GET_ALL_FORMULATION_SUCCESS,
    GET_ALL_FORMULATION_ERROR,
    ADD_FORMULATION_BEGIN,
    ADD_FORMULATION_SUCCESS,
    ADD_FORMULATION_ERROR,
    GET_FORMULATION_BEGIN,
    GET_FORMULATION_SUCCESS,
    GET_FORMULATION_ERROR,
    UPDATE_FORMULATION_BEGIN,
    UPDATE_FORMULATION_SUCCESS,
    UPDATE_FORMULATION_ERROR,
    DELETE_FORMULATION_BEGIN,
    DELETE_FORMULATION_SUCCESS,
    DELETE_FORMULATION_ERROR
 } from './constants'

  const initState = {
    list: [],
    loading: false,
    error: null,
  };
  
  const FormulationReducer = (state = initState, action) => {
    const { type, data, error } = action;
    switch (type) {
      case GET_ALL_FORMULATION_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case GET_ALL_FORMULATION_SUCCESS:
        return {
          ...state,
          list: data,
          loading: false,
        };
      case GET_ALL_FORMULATION_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case ADD_FORMULATION_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case ADD_FORMULATION_SUCCESS:
        return {
          ...state,
          loading: false,
          list: [...state.list, data],
        };
      case ADD_FORMULATION_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case GET_FORMULATION_BEGIN:
        return {
          ...state,
          loading: true,
          FormulationData: "",
        };
      case GET_FORMULATION_SUCCESS:
        return {
          ...state,
          loading: false,
          FormulationData: data,
        };
      case GET_FORMULATION_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case UPDATE_FORMULATION_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case UPDATE_FORMULATION_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.map((ele) => {
            if (ele.id === data.id) {
              return { ...data };
            } else return ele;
          }),
        };
      case UPDATE_FORMULATION_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case DELETE_FORMULATION_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case DELETE_FORMULATION_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.filter((ele) => ele.id !== data.id),
        };
      case DELETE_FORMULATION_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default FormulationReducer;
  